import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../../api";

import { TabContent, TabPane, Nav, NavItem, NavLink, Label, Input, FormFeedback, Table } from 'reactstrap';

import ParadigmaAsyncSeeker from "../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"

import InputMask from 'react-input-mask';
import 'react-datepicker/dist/react-datepicker.css';

import DatePicker from 'react-datepicker';
import moment from 'moment';

class Detail extends Component {
    constructor(props) {
        super(props);
        this.state = {
            datos: [],
            datosDelete: [],
            aclaracionesDelete: [],
            aclaraciones: [],
            porcentaje: null,
            persona_id: null,
            persona_nombre: "",
            total: 0,
            solicitud: null,
            proyecto_codigo: null,
            resumen: "",
            fechaFin: moment(),
            fechaInicio: moment(),
            activeTab: 1,
        };
    }



    static propTypes = {
        id: PropTypes.func.isRequired,
    }

    resetState() {
        this.setState({
            datos: [],
            datosDelete: [],
            aclaracionesDelete: [],
            aclaraciones: [],
            porcentaje: null,
            persona_id: null,
            persona_nombre: "",
            rol_id: null,
            rol_nombre: "",
            total: 0,
            solicitud: "",
            proyecto_codigo: "",
            resumen: "",
            fechaFin: moment(),
            fechaInicio: moment(),
            activeTab: 1,
        })
    }

    setSelects(data) {

        var total = 0;
        data.datos.forEach(x => total += x.porcentaje);
        this.setState({
            datos: data.datos,
            total: total,
            solicitud: data.solicitud_id,
            proyecto_codigo: data.codigo,
            resumen: (data.resumen != null ? data.resumen : ""),
            fechaInicio: (data.fechaInicio != null ? moment(data.fechaInicio) : moment()),
            fechaFin: (data.fechaFin != null ? moment(data.fechaFin) : moment()),
            aclaraciones: (data.aclaraciones ? data.aclaraciones : []),
            montoAclaracion: data.montoAclaracion,
        });
    }

    getActiveClass(tabN) {
        if (this.state.activeTab == tabN)
            return "active";
        else
            return "";
    }

    toggleTab(tab) {
        if (this.state.activeTab !== tab) {
            this.setState({
                activeTab: tab
            });
        }
    }

    AddToTable() {
        var datos = this.state.datos;

        var existdato = datos.filter(x => x.persona_id == this.state.persona_id && x.rol_id == this.state.rol_id);
        if (existdato.length > 0) {
            existdato[0].porcentaje += this.state.porcentaje;
        } else {
            datos.push({
                persona_id: this.state.persona_id,
                nombre: this.state.persona_nombre,
                rol_id: this.state.rol_id,
                rol_nombre: this.state.rol_nombre,
                porcentaje: this.state.porcentaje
            });
        }

        var total = 0;
        datos.forEach(x => total += x.porcentaje);

        this.setState({
            datos: datos,
            persona_id: 0,
            rol_id: 0,
            rol_nombre: "",
            persona_nombre: "",
            porcentaje: 0,
            total: total,
        })
    }

    onChangeInput(row, value) {
        var datos = this.state.datos;
        datos[row].porcentaje = parseInt(value);

        var total = 0;
        datos.forEach(x => total += x.porcentaje);
        if (total <= 100)
            this.setState({
                datos: datos,
                total: total
            });

    }

    removeRow(persona_id, rol_id) {
        var datos = this.state.datos.filter(x => x.persona_id != persona_id || x.rol_id != rol_id);
        var datosDelete = this.state.datosDelete;
        var newdatosDelete = this.state.datos.filter(x => x.persona_id == persona_id && x.rol_id == rol_id).filter(x => x.id != null).map(x => x.id);

        for (var i = 0; i < newdatosDelete.length; i++) {
            datosDelete.push(newdatosDelete[i]);
        }

        var total = 0;
        datos.forEach(x => total += x.porcentaje);
        this.setState({
            datos: datos,
            total: total,
            datosDelete
        });
    }

    changePorcentaje(e) {
        var value = parseInt(e.target.value);
        if (value > 0) {
            var total = 0;
            this.state.datos.forEach(x => total += x.porcentaje);
            if (total + value <= 100)
                this.setState({ porcentaje: value });
            else {
                this.setState({ porcentaje: 100 - total });
                e.preventDefault();
            }
        }
        else {
            this.setState({ porcentaje: 0 });
            e.preventDefault();
        }
    }

    render() {
        const { aclaraciones } = this.state;
        var atr = [];
        if (this.state.datos) {
            for (var i = 0; i < this.state.datos.length; i++) {
                let rowN = i.toString();
                let row = this.state.datos[i];
                atr.push(
                    <tr key={i}>
                        <td className="d-none">
                            <Input type="number" name={"datos[" + rowN + "][id]"} className="p-0 d-none" value={row.id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                            <Input type="number" name={"datos[" + rowN + "][persona_id]"} className="p-0 d-none" value={row.persona_id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                            <Input type="number" name={"datos[" + rowN + "][rol_id]"} className="p-0 d-none" value={row.rol_id} onChange={(e) => this.onChangeInput(rowN, e.target)} />
                        </td>
                        <td>
                            {row.nombre}
                        </td>
                        <td>
                            {row.rol_nombre}
                        </td>
                        <td>
                            <Input type="number" disabled={true} name={"datos[" + rowN + "][porcentaje]"} value={row.porcentaje} onChange={(e) => this.onChangeInput(rowN, e.target.value)} className="form-control text-right" />
                        </td>
                    </tr>
                );
            }
        }



        return (
            <ParadigmaModal
                getUrl={api.proyectos.cargadatos.detail}
                id={this.props.id}
                missingIdMessage={"Debe seleccionar una fila."}
                title={"Detalle"}
                buttonTitle={"Ver Certificación"}
                buttonIcon={"fa fa-search fa-lg"}
                saveButton={false}
                closeButton={true}
                onGotData={(data) => this.setSelects(data)}
                onClose={() => this.resetState()}
                className={"ui-modal-dialog ui-modal-editor"}>
                <div className="ui-form">
                <Nav tabs>
                    <NavItem>
                        <NavLink className={this.getActiveClass(1)} onClick={() => { this.toggleTab(1); }}>
                            Certificación
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink className={this.getActiveClass(2)} onClick={() => { this.toggleTab(2); }}>
                            Aclaraciones
                        </NavLink>
                    </NavItem>
                </Nav>
                <TabContent activeTab={this.state.activeTab}>
                    <TabPane tabId={1}>
                        <Input type="hidden" name="DatosDelete" onChange={(e) => { return; }} value={this.state.datosDelete.join(',')}></Input>
                        <div className="ui-section-grid">
                            <section className="ui-section-block ui-section-span-2">
                                <p className="ui-section-label">Datos del proyecto</p>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Código</Label>
                                        <ParadigmaAsyncSeeker pkField={"codigo"} nombreField={"cod"} fieldName={""} url={api.proyectos.solicitudes.selectcodigo} value={this.state.proyecto_codigo} disabled={true} />
                                        <FormFeedback />
                                    </div>
                                </div>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Proyecto</Label>
                                        <ParadigmaAsyncSeeker fieldName={"solicitud_id"} url={api.proyectos.solicitudes.select} value={this.state.solicitud} disabled={true} />
                                        <FormFeedback />
                                    </div>
                                </div>

                                <div className="ui-row-2">
                                    <div className="ui-field">
                                        <Label>Fecha Inicio</Label>
                                        <DatePicker
                                            selected={this.state.fechaInicio}
                                            onChange={(e) => this.setState({ 'fechaInicio': e })}
                                            disabled={true}
                                            timeFormat=""
                                            className="form-control"
                                            name={"fechaInicio"}
                                            timeIntervals={15}
                                            dateFormat="DD/MM/YYYY"
                                            timeCaption="time"
                                            customInput={<InputMask name="fechaInicio" className="form-control" mask="99/99/9999" type="text" />}
                                        />
                                        <FormFeedback />
                                    </div>
                                    <div className="ui-field">
                                        <Label>Fecha Fin</Label>
                                        <DatePicker
                                            selected={this.state.fechaFin}
                                            onChange={(e) => this.setState({ 'fechaFin': e })}
                                            disabled={true}
                                            timeFormat=""
                                            className="form-control"
                                            name={"fechaFin"}
                                            timeIntervals={15}
                                            dateFormat="DD/MM/YYYY"
                                            timeCaption="time"
                                            customInput={<InputMask name="fechaFin" className="form-control" mask="99/99/9999" type="text" />}
                                        />
                                        <FormFeedback />
                                    </div>
                                </div>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                        <Label>Monto</Label>
                                        <Input type="text" disabled className="text-left" name="montoAclaracion"
                                            value={(this.state.montoAclaracion ? this.state.montoAclaracion : "")}
                                        ></Input>
                                    </div>
                                </div>
                            </section>

                            <section className="ui-section-block ui-section-span-2">
                                <p className="ui-section-label">Personal asignado</p>
                                <Table className="ui-table table-sm">
                                    <thead>
                                        <tr>
                                            <th className="d-none">QUITAR</th>
                                            <th className="col-1">Persona</th>
                                            <th className="col-1">Rol</th>
                                            <th className="col-1">Porcentaje</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {atr}
                                    </tbody>
                                    <tfoot>
                                        <tr>
                                            <th colSpan="2" className="col-1">Total</th>
                                            <th colSpan="2" className="col-1">
                                                <Input type="number" className="text-right" disabled={true}
                                                    onChange={(e) => { return; }} value={(this.state.total ? this.state.total : 0)}></Input>
                                            </th>
                                        </tr>
                                    </tfoot>
                                </Table>
                            </section>

                            <section className="ui-section-block ui-section-span-2 ui-section-compact">
                                <p className="ui-section-label">Resumen</p>
                                <div className="ui-row-1">
                                    <div className="ui-field">
                                <Label>Resumen <small className={(this.state.resumen.length > 1500 ? "badge badge-danger" : "")}>({this.state.resumen.length}/1500)</small></Label>
                                <Input rows={5} disabled={true} type="textarea" name="resumen" value={this.state.resumen} onChange={(e) => { return; }} />
                                <FormFeedback />
                                    </div>
                                </div>
                            </section>
                        </div>
                    </TabPane>
                    <TabPane tabId={2}>
                        <section className="ui-section-block">
                            <p className="ui-section-label">Aclaraciones</p>
                                <Table className="ui-table table-sm">
                                    <thead>
                                        <tr>
                                            <th>Motivo</th>
                                            <th>Aclaración</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {aclaraciones && aclaraciones.map((row, i) =>
                                            <tr key={i}>
                                                <td>
                                                    <Input type="text" disabled value={row.motivo} />
                                                </td>
                                                <td>
                                                    <Input type="text" disabled value={row.aclaracion} />
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </Table>
                        </section>
                    </TabPane>
                </TabContent>
                </div>
            </ParadigmaModal >
        );
    }
}

export default Detail;



// WEBPACK FOOTER //
// ./src/views/Proyectos/Procedimiento5/Detail.js